import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
import SEO from '../components/SEO';

const TermsPage = () => {
  return (
    <div className="min-h-screen pt-24 pb-16 bg-slate-950" data-testid="terms-page">
      <SEO 
        title="Terms of Service"
        description="Read the Terms of Service for Bit Buddies, your marketplace for innovative software ideas."
        url="/terms"
      />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <Link to="/" className="inline-flex items-center text-slate-400 hover:text-white mb-8 transition-colors">
          <ArrowLeft className="mr-2 h-4 w-4" />
          Back to Home
        </Link>

        <div className="flex items-center gap-3 mb-8">
          <FileText className="h-8 w-8 text-cyan-400" />
          <h1 className="font-heading text-3xl md:text-4xl font-bold text-white">Terms of Service</h1>
        </div>

        <div className="prose prose-invert max-w-none">
          <p className="text-slate-400 mb-6">Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>

          <div className="space-y-8 text-slate-300">
            <section>
              <h2 className="font-heading text-xl font-semibold text-white mb-4">1. Acceptance of Terms</h2>
              <p>By accessing and using the Bit Buddies platform ("Service"), you accept and agree to be bound by the terms and provisions of this agreement. If you do not agree to abide by these terms, please do not use this Service.</p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-semibold text-white mb-4">2. Description of Service</h2>
              <p>Bit Buddies is a platform for showcasing, selling, and investing in software and systems ideas. The Service allows users to browse ideas, submit inquiries, and make purchases or investments in presented concepts.</p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-semibold text-white mb-4">3. User Obligations</h2>
              <p>You agree to:</p>
              <ul className="list-disc pl-6 mt-2 space-y-2">
                <li>Provide accurate and complete information when submitting inquiries or making purchases</li>
                <li>Use the Service only for lawful purposes</li>
                <li>Not attempt to gain unauthorized access to any portion of the Service</li>
                <li>Not reproduce, duplicate, copy, sell, or exploit any portion of the Service without express permission</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-xl font-semibold text-white mb-4">4. Intellectual Property</h2>
              <p>All ideas, concepts, designs, and content displayed on Bit Buddies remain the intellectual property of Bit Buddies or its licensors until a valid purchase or licensing agreement has been executed. Browsing the platform does not grant any rights to the intellectual property displayed.</p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-semibold text-white mb-4">5. Purchases and Investments</h2>
              <p>All purchases and investments are subject to separate agreements that will be provided upon transaction. Prices displayed are subject to change without notice. Bit Buddies reserves the right to refuse any transaction at its sole discretion.</p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-semibold text-white mb-4">6. Payment Terms</h2>
              <p>Payments are processed through secure third-party payment processors. By making a payment, you agree to the terms of service of our payment processor. All sales are final unless otherwise specified in a separate agreement.</p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-semibold text-white mb-4">7. Disclaimer of Warranties</h2>
              <p>THE SERVICE IS PROVIDED "AS IS" WITHOUT WARRANTY OF ANY KIND. BIT BUDDIES DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.</p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-semibold text-white mb-4">8. Limitation of Liability</h2>
              <p>IN NO EVENT SHALL BIT BUDDIES BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING OUT OF OR RELATED TO YOUR USE OF THE SERVICE.</p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-semibold text-white mb-4">9. Modifications to Terms</h2>
              <p>Bit Buddies reserves the right to modify these terms at any time. Continued use of the Service after any such changes constitutes your acceptance of the new terms.</p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-semibold text-white mb-4">10. Governing Law</h2>
              <p>These Terms shall be governed by and construed in accordance with the laws of the State of Texas, without regard to its conflict of law provisions.</p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-semibold text-white mb-4">11. Contact Information</h2>
              <p>For questions about these Terms of Service, please contact us at:</p>
              <p className="mt-2">
                <strong className="text-white">Email:</strong> MDH@BitBuddies.online<br />
                <strong className="text-white">Location:</strong> Addison, TX
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
